import { Component, OnInit } from '@angular/core';
import { ClientService } from 'src/app/services/client.service';
import { DropboxService } from 'src/app/services/dropbox.service';
import { ContextService } from '../../services/context.service';

@Component({
	selector: 'app-configure',
	templateUrl: './configure.component.html',
	styleUrls: ['./configure.component.css']
})
export class ConfigureComponent implements OnInit {
	loadingDropbox = false;

	showAuthenticateMessage = false;

	showDropboxFolderSelector = false;
	dropboxFolders = [];

	constructor(
		private clientService: ClientService,
		public contextService: ContextService,
		private dropboxService: DropboxService
	) { }

	ngOnInit() {
		this.retrieveDropboxFolders();
	}

	retrieveDropboxFolders() {
		this.loadingDropbox = true;
		this.dropboxService.getRootFolders(this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
			.subscribe({
				next: (folders: any) => {
					this.dropboxFolders = folders;
					this.loadingDropbox = false;
				},
				error: (err: any) => {
					console.log('error');
					console.log(err);
					this.loadingDropbox = false;
				}
			});
	}

	authenenticateDropbox() {
		this.loadingDropbox = true;
		this.dropboxService.getAuthUrl(this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
			.subscribe({
				next: (response) => {
					window.open(response, '_blank');

					this.showAuthenticateMessage = true;
					this.loadingDropbox = false;
				},
				error: () => {
					// No user exists, do nothing.
					this.loadingDropbox = false;
				}
			});
	}

	unauthenenticateDropbox() {

	}

	refreshAfterDropboxAuth() {
		this.loadingDropbox = true;
		this.dropboxService.getUserAccount(this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
			.subscribe({
				next: (response) => {
					this.contextService.dropboxAccount = response;
					this.loadingDropbox = false;
				},
				error: () => {
					this.loadingDropbox = false;
				}
			});
	}

	selectParentFolder(folderId) {
		console.log(folderId);
		this.loadingDropbox = true;
		this.clientService.updateClient(this.contextService.procoreContextObject.context.company_id, folderId, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
			.subscribe({
				next: (response) => {
					this.contextService.client = response;
					this.showDropboxFolderSelector = false;
					this.loadingDropbox = false;
				},
				error: () => {
					this.showDropboxFolderSelector = false;
					this.loadingDropbox = false;
				}
			});
	}

	expandFolder(folder) {

	}
}
